<template>
  <base-form-field v-slot="data" :name :rule>
    <div class="space-y-1" :class="classWrapper" :data-test-id="`vf-form-field-${name}`">
      <!-- @slot Slot for form control -->
      <slot
        v-bind="{
          ...data,
          attrs: {
            ...data.attrs,
            'aria-describedby': [hint ? name : '', data.message ? `${name}-error` : ''].filter(Boolean).join(' '),
          },
        }"
      />
      <vf-form-hint v-if="hint" :id="name" :data-test-id="`vf-form-hint-${name}`" :variant>
        {{ hint }}
      </vf-form-hint>
      <vf-form-error v-if="data.message" :id="`${name}-error`" :data-test-id="`vf-form-error-${name}`" :variant>
        {{ data.message }}
      </vf-form-error>
    </div>
  </base-form-field>
</template>

<script lang="ts" setup>
import type { CSSClass } from '#types/common'
import type { Rule } from '#types/components/base/form'

const { rule = [] } = defineProps<{
  /**
   * Defines classList of content's wrapper excluding pagination section
   */
  classWrapper?: CSSClass
  /**
   * This prop will be used as a key to register validation rule in form
   */
  name: string
  /**
   * Validation rule for value registered in form by `name` prop
   */
  rule?: Rule
  /**
   * Hint that will be displayed under the form control
   */
  hint?: string
  /**
   * Defines variant
   */
  variant?: 'inverse'
}>()
</script>
